module.exports = __webpack_public_path__ + "static/afterclimb_montage-d16228875fe9ce4d1abdb6875cbcf5f0.jpg";